import { type PasswordChangeErrors } from '@app-types/api/auth'
import { passwordChangeFieldLabels } from './constants'

function fieldTitle(field: string) {
  return (
    passwordChangeFieldLabels[
      field as keyof typeof passwordChangeFieldLabels
    ] ?? field
  )
}

export function flattenPasswordChangeErrors(errors?: PasswordChangeErrors) {
  if (!errors) {
    return []
  }

  return Object.entries(errors).flatMap(([field, items]) =>
    items.map((item) => `${fieldTitle(field)}: ${item.message}`),
  )
}
